import store from '../store/index'
import { setSession, delSession } from '@/api/common'
import themes from '@/util/themes'
import { updateUserInfo } from '@/api/personal'
/**
 * 请求登录接口 返回的参数储存
 * @param {*}  res 获取到的直播地址
 * @returns
 */
export function loginStorage(res, style) {
  setSession('loginUserName', res.account)
  setSession('username', res.username)
  setSession('userId', res.userId)
  setSession('tenantId', res.tenantId)
  setSession('access_token', res.token_type + ' ' + res.access_token)
  setSession('refresh_token', res.refresh_token)
  delSession('expireTime')
  setSession('expireTime', res.expiration)
  // res.platformStyle = 1
  if (style) {
    res.platformStyle = style === 'dark' ? 1 : 0
    setSession('styleLogin', res.platformStyle)
    if (style === 'dark') {
      themes('dark')
      store.commit('switchTheme', 'dark')
    } else {
      themes('default')
      store.commit('switchTheme', 'default')
    }
    let param = {
      platformStyle: res.platformStyle,
    }
    updateUserInfo(param).then(res => {
      console.log(param, res)
    })
  } else {
    themes(res.platformStyle === 1 ? 'dark' : 'default')
    store.commit('switchTheme', res.platformStyle === 1 ? 'dark' : 'default')
  }
  if (res.tenantConfig) {
    localStorage.setItem('DEVICE_SPEC_MODEL', res.tenantConfig['DEVICE_SPEC_MODEL'])
    localStorage.setItem('DEVICE_SPEC_TYPE', res.tenantConfig['DEVICE_SPEC_TYPE'])
    store.commit('changeDeviceSpecModel', res.tenantConfig['DEVICE_SPEC_MODEL'])
    store.commit('changeDeviceSpecType', res.tenantConfig['DEVICE_SPEC_TYPE'])
  } else {
    localStorage.setItem('DEVICE_SPEC_MODEL', '')
    localStorage.setItem('DEVICE_SPEC_TYPE', '')
    store.commit('changeDeviceSpecModel', '')
    store.commit('changeDeviceSpecType', '')
  }
}
